<script>
import { methods } from "./constants.js";
import ContainerData from "./container-data.vue";

import Examanes from "./pages/examanes.vue";
import ExamenesForm from "./forms/examenes-form.vue";


import BtnAddCardTable from "@/components/btnCardTable/btnAddCardTable.vue";
import { mapState } from "vuex";


export default {
  components: {
    ContainerData,
    Examanes,
    ExamenesForm,
    BtnAddCardTable,
  },
  data() {
    return {
      currentMethod: {},
      methods,
      txtSearch: "",
      ID_OFFICES: 1,
      ID_BREATHALYZERS: 2,
      ID_ARRIVALS: 3,
      activeDataNotFound: false,
      cacheData: [],
      token: null,
      tokenParametricas: null
    };
  },

  computed: {
    ...mapState("terminales", ["allDataTerminals"]),
  },

  methods: {
    // handlerActiveFase(method) {
    //   sessionStorage.setItem("currentMethod", JSON.stringify(method));
    //   this.currentMethod = method;
    //   this.cacheData = this.allDataTerminals[this.currentMethod.name].slice();
    // },

    // async fetchModules() {
    //   await this.$store.dispatch("terminales/getCodesTerminal");
    //   await this.$store.dispatch("terminales/getDivipolaCodes");
    //   await this.$store.dispatch("terminales/getListTypesDocs");
    //   await this.$store.dispatch("terminales/getAllDataTerminals");
    //   this.$store.dispatch("terminales/getPassengerOptions");

    //   this.cacheData = this.allDataTerminals[this.currentMethod.name].slice();
    // },
    // async handleSearchCurrentTerminals() {
    //   /**@typedef {import('./types').Offices} Offices */
    //   /**@typedef {import('./types').Examanes} Examanes */
    //   /**@typedef {import('./types').Arrivals} Arrivals */

    //   if (this.txtSearch && this.currentMethod.id === this.ID_OFFICES) {
    //     /**@type {Offices[]} */
    //     const officesData = this.allDataTerminals["Despachos"];

    //     const filtereofficesData = officesData.filter((officeItem) => {
    //       const plate = officeItem.placa.toLowerCase();
    //       return plate.includes(this.txtSearch.toLowerCase());
    //     });

    //     if (filtereofficesData.length) {
    //       this.allDataTerminals["Despachos"] = filtereofficesData;
    //     }
    //   } else if (
    //     this.txtSearch &&
    //     this.currentMethod.id === this.ID_BREATHALYZERS
    //   ) {
    //     /**@type {Examanes[]} */
    //     const breathalyzersData = this.allDataTerminals["Alcoholimetrias"];

    //     const filtereofficesData = breathalyzersData.filter(
    //       (breathalyzerItem) => {
    //         const nameDriver = breathalyzerItem.nombreConductor.toLowerCase();
    //         return nameDriver.includes(this.txtSearch.toLowerCase());
    //       }
    //     );

    //     if (filtereofficesData.length) {
    //       this.allDataTerminals["Alcoholimetrias"] = filtereofficesData;
    //     }
    //   } else if (this.txtSearch && this.currentMethod.id === this.ID_ARRIVALS) {
    //     /**@type {Arrivals[]} */
    //     const arrivalsData = this.allDataTerminals["Llegadas"];

    //     const filtereofficesData = arrivalsData.filter((arrivalItem) => {
    //       const plate = arrivalItem.placa.toLowerCase();
    //       return plate.includes(this.txtSearch.toLowerCase());
    //     });

    //     if (filtereofficesData.length) {
    //       this.allDataTerminals["Llegadas"] = filtereofficesData;
    //     }
    //   } else {
    //     this.allDataTerminals[this.currentMethod.name] = this.cacheData;
    //   }
    // },

    async obtenerToken() {
      try {
        const respuesta = await this.$store.dispatch("hl_post_cookie",
          {
            path: 'ApiSuperTransporteGenerales/TokenApiSuperTransporte'
          }
        )
        console.log("Token obtenido", respuesta);

      } catch (error) {
        console.warn("No se ha logrado generar el token", error);

      }
    },
    async obtenerTokenParametricas() {
      try {
        const respuesta = await this.$store.dispatch("hl_post_cookie",
          {
            path: 'ApiSuperTransporteGenerales/TokenParametricas'
          }
        )
        console.log("Token parámetricas obtenido", respuesta);

      } catch (error) {
        console.warn("No se ha logrado generar el token de parámetricas", error);

      }
    }
  },
  async mounted() {
    await this.obtenerToken();
    await this.obtenerTokenParametricas();
    const getCurrentMethodStorage =
      JSON.parse(sessionStorage.getItem("currentMethod")) ?? this.methods[0];

    this.currentMethod = getCurrentMethodStorage;
    //this.fetchModules();

  },
};
</script>

<template>
  <card>
    <div class="custom-container">
      <h3 class="p-3 d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <b> Sistema de Gestión : Terminales </b>
      </h3>
      <hr />
      <div class="row  col-12 align-items-center justify-content-around" style="gap: 0.5rem">
        <div class="col-12 col-lg-8 d-flex flex-wrap flex-sm-nowrap" style="gap: 1rem">
          <div v-for="method of methods" :key="method.id" class="bg-dark bg-dark-hover p-3 rounded" :style="{
            transition: 'box-shadow 0.3s ease',
            boxShadow:
              currentMethod.id == method.id
                ? 'inset 0 0 0 2px #1A5CFF'
                : 'none',
            cursor: 'default',
          }">
            <h5>
              {{ method.name }}
            </h5>
            <p class="text-white-50">{{ method.description }}</p>
          </div>
        </div>
        <!-- btn add  -->
        <div class="col-12 col-lg-3">
          <BtnAddCardTable class="py-5 d-flex justify-content-end" v-b-modal.modalTerminales
            :text="` Ingresar ${currentMethod.name}`" />
        </div>
      </div>
      <!-- 
      <div class="row my-5">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div style="position: relative">
            <input v-model="txtSearch" type="search" id="inputSearch" class="form-control" placeholder="Buscar..."
              @input="handleSearchCurrentTerminals" />
            <vs-avatar circle dark id="icon-search" class="d-flex align-items-center justify-content-center"
              type="submit">
              <i class="fas fa-search fa-fade"></i>
            </vs-avatar>
          </div>
        </div>
      </div> -->

      <!-- <ContainerData v-if="currentMethod.id === ID_OFFICES">
        <Offices />
      </ContainerData> -->
      <ContainerData v-if="currentMethod.id === ID_BREATHALYZERS">
        <Examanes />
      </ContainerData>
      <!-- <ContainerData v-if="currentMethod.id === ID_ARRIVALS">
        <Arrivals />
      </ContainerData> -->

      <b-modal id="modalTerminales" size="xl" hide-footer hide-header body-class=" bg-dark">
        <!-- <OfficesForm v-if="currentMethod.id === ID_OFFICES" /> 
        <ArrivalsForm v-if="currentMethod.id === ID_ARRIVALS" /> 
        -->
        <ExamenesForm v-if="currentMethod.id === ID_BREATHALYZERS" />
      </b-modal>
    </div>
  </card>
</template>

<style lang="css">
.bg-button-dark {
  background-color: #10213b;
}

#inputSearch {
  width: 380px;
  max-width: 430px;
  height: 50px;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 700;
  transition: all 0.5s;
  border: none;
}

#inputSearch:focus {
  width: 430px;
  box-shadow: inset 0 0 0 2px rgb(242, 19, 93);
}

#inputSearch::placeholder {
  font-size: 1.2rem;
  font-weight: 700;
}

#icon-search {
  position: absolute;
  transition: 0.5s;
  top: 50%;
  transform: translate(0, -50%);
  right: 10px !important;
}
</style>
